<template>
  <v-tabs :v-once="query" left>
    <v-tab ripple>
      {{ info.title }}
    </v-tab>
    <v-tab-item>
      <v-card flat>
        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>Main Information</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text v-if="policyInfo.polNo !== undefined">
                <v-container fluid grid-list-sm>
                  <v-layout row wrap xs12>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Policy No.</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span class="title">{{ policyInfo.polNo }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Renewal/Endt</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ policyInfo.renCnt }}/{{ policyInfo.endtCnt }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Policy Status</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.polStat }} - {{ policyInfo.polStatDesc }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Billing Account</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.acctNo1 }} - {{ policyInfo.name }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Insured Name</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <strong>{{ polMaster.insdRefNo }} - {{ policyInfo.insured }} {{ polMaster.insdName2 }} {{ polMaster.insdName3 }}</strong>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Period of Cover</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ formatDate(policyInfo.fromDate) }} - {{ formatDate(policyInfo.endDate) }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Maintanence Period</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.maintPer }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Defect Liability Period</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.dliabPer }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Underwriting Year</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ policyInfo.uwYear }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Endorsement Date</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ formatDate(polMaster.endtDate) }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Transaction Date</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ formatDate(polMaster.tranDate) }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ formatDate(polMaster.acceptDate) }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">First Issue Date</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ formatDate(polMaster.firstIssDate) }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Direct/RI Inwards</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.dri === true">Direct</span>
                      <span v-else>RI Inwards</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Policy Type</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.polType }} - {{ policyInfo.polTypeDesc }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Country of Risk</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.cty }} - {{ policyInfo.ctyDesc }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Fund</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.fund }} - {{ policyInfo.fundDescription }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Branch</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.branch }} - {{ policyInfo.branchDesc }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Department</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.dept }} - {{ policyInfo.deptDesc }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Business Source</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.busSrc }} - {{ policyInfo.busSrcDesc }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Scheme</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.scheme">{{ polMaster.scheme }} - {{ policyInfo.schemeDesc }}</span>
                      <span v-else> - </span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Plan No</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.planNo">{{ polMaster.planNo }} - {{ polMaster.planDesc }}</span>
                      <span v-else> - </span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-divider class="grey lighten-3"></v-divider>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>Other Information</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text v-if="policyInfo.polNo !== undefined">
                <v-container fluid grid-list-sm>
                  <v-layout row wrap xs12>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Previous Policy No.</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.prevPolNo">{{ polMaster.prevPolNo }}</span>
                      <span v-else> - </span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Renewal Policy No.</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.renPolNo">{{ polMaster.renPolNo }}</span>
                      <span v-else> - </span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">CN No./CN Date</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.cnNo">{{ polMaster.cnNo }} - {{ polMaster.cnDate }}</span>
                      <span v-else> - </span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">IPC No.</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.ipcNo">{{ polMaster.ipcNo }} {{ polMaster.ipcSeqNo }}</span>
                      <span v-else> - </span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">IPC Status / IPC Date</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.ipcStatus }} - {{ polMaster.ipcDate }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Billing Currency</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.billCurr }} {{ formatDisplayNumber(polMaster.billCurrRate, 6) }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">No. of Instalments</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.totNoInstal }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Payment Method</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span>{{ polMaster.paytMeth }} - {{ policyInfo.paytMethDesc }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Finance Company</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.finInst">{{ polMaster.finInst }} - {{ policyInfo.finInstName }}</span>
                      <span v-else> - </span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Corporate Partner</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.cpCode">{{ polMaster.cpCode }} - {{ policyInfo.armName }}</span>
                      <span v-else> - </span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Batch Release Later</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.batchRel === true">{{ formatBoolean(polMaster.batchRel) }}</span>
                      <span v-else>{{ formatBoolean(polMaster.batchRel) }}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-subheader class="queryLabel">Enter RI Later</v-subheader>
                    </v-flex>
                    <v-flex xs8>
                      <span v-if="polMaster.entRilater === true">{{ formatBoolean(polMaster.entRilater) }}</span>
                      <span v-else>{{ formatBoolean(polMaster.entRilater) }}</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-expansion-panel-content>
            <div slot="header" class="body-2"></div>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap xs12>
                  <v-flex xs4>
                    <v-subheader class="queryLabel">Entered by</v-subheader>
                  </v-flex>
                  <v-flex xs8>
                    <span v-if="policyInfo.createdName || polMaster.createdDate"
                      >{{ policyInfo.createdName }} on {{ formatDate(polMaster.createdDate) }}</span
                    >
                    <span v-else> - </span>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader class="queryLabel">Last Updated by</v-subheader>
                  </v-flex>
                  <v-flex xs8>
                    <span v-if="policyInfo.modifiedName || polMaster.modifiedDate"
                      >{{ policyInfo.modifiedName }} on {{ formatDate(polMaster.modifiedDate) }}</span
                    >
                    <span v-else> - </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-tab-item>
    <v-tab ripple> Cedant Info </v-tab>
    <v-tab-item>
      <cedant-info></cedant-info>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import CedantInfo from './CedantInfo'

export default {
  computed: {
    policyInfo() {
      return this.$store.state.underwriting.policy.policyInfo
    },
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    },
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    }
  },
  data() {
    return {
      panel: [0],
      labels: {
        renCnt: 'Renewal: ',
        endtCnt: 'Endorsement: '
      },
      info: {
        title: 'Policy Info',
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        polTypeDesc: undefined,
        branch: undefined,
        fundDesc: undefined,
        fromDate: undefined,
        endDate: undefined,
        uwYear: undefined,
        insured: undefined
      }
    }
  },
  components: {
    CedantInfo
  },
  props: {
    query: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.infoField {
  line-height: 2em;
  .infoLabel {
    vertical-align: top;
    display: inline-block;
    width: 150px;
  }
  .infoValue {
    vertical-align: top;
    display: inline-block;
    font-weight: 500;
    text-align: center;
  }
}
</style>
